import React from "react";
import pfp1 from "../asset/SarahK.webp"
import pfp2 from "../asset/AhmadM.webp"
import pfp3 from "../asset/SophiaA.webp"
import pfp4 from "../asset/DavidL.webp"
import pfp5 from "../asset/AishaF.webp"

function Testimonial() {

  const testimony = [
    {
      name:"Sarah K.",
      occupation: "Investor",
      img: pfp1,
      msg: "Working with Haideries was an absolute game-changer for my investment portfolio. Their team guided me through every step. Thanks to Haideries I purchased multiple properties in Dubai, and their expertise maximized my ROI significantly."
    },
    {
      name:"Ahmed M.",
      occupation: "Homebuyer",
      img: pfp2,
      msg: "I can't recommend Haideries enough! As a first-time homebuyer, I had many doubts, but their agents were patient and incredibly knowledgeable. They helped me find the perfect home within my budget and made the entire process stress-free."
    },
    {
      name:"Sophia A.",
      occupation: "Seller",
      img: pfp3,
      msg: "Selling my property in Dubai was seamless, thanks to Haideries. Their marketing strategies attracted numerous potential buyers, and their negotiation skills ensured I got the best value for my property. I was thrilled with the results!"
    },
    {
      name:"David L.",
      occupation: "Investor",
      img: pfp4,
      msg: "Haideries' insight into the Dubai real estate market is unmatched. Their market analysis and recommendations were spot-on. I've made substantial gains from the properties they helped me invest in. Their professionalism is top-notch."
    },
    {
      name:"Aisha F.",
      occupation: "Renter",
      img: pfp5,
      msg: "Haideries made finding a rental property in Dubai hassle-free. Their agents were attentive, listened to my preferences, and presented several options that met my criteria. Renting my dream home was a breeze, all thanks to them!"
    },
  ];

  const testimonies = testimony.map((ele, it) => {
    return (
      <div key={it} className="flex-none w-[85vw] sm:w-[380px] md:w-[440px]">
        <div className="bg-white p-5 sm:p-6 rounded-xl shadow-md h-full flex flex-col justify-between border border-gray-100 hover:shadow-lg transition-shadow">
          <p className="mb-6 text-xs sm:text-sm md:text-base text-gray-700 leading-relaxed">
            "{ele.msg}"
          </p>
          <div className="flex items-center pt-3 border-t border-gray-100">
            <img className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-bluColor" src={ele.img} loading="lazy" alt={ele.name} />
            <div className="ml-3 sm:ml-4">
              <h2 className="font-bold text-sm sm:text-base text-gray-900">{ele.name}</h2>
              <h3 className="text-xs text-gray-500">{ele.occupation}</h3>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div id="Testimonials" className="bg-gray-200 py-12 sm:py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 mb-6 sm:mb-8">
        <h1 className="font-light tracking-wider text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-3">
          CLIENT'S TESTIMONIALS
        </h1>
        <p className="max-w-3xl text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
          Discover the positive impact we've made on our clients by reading through their testimonials. Our clients have experienced our service and results, and they're eager to share their positive experiences with you.
        </p>
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24">
        <div className="w-full overflow-x-auto scrollbar-hide cursor-grab py-2">
          <div className="flex gap-4 sm:gap-6 pb-2">
            {testimonies}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonial;